import { TableProperties } from "PFApp/components/table_properties/table_properties";
import { Stack } from "PFComponents/containers/flex";
import SidePanel from "PFComponents/side_panel/side_panel";
import { useOptionalTranslation } from "PFCore/hooks/use_optional_translation";
import { TableColumn } from "PFTypes";

type TablePropertiesProps = {
  isVisible: boolean;
  onCloseClick: () => void;
  onColumnsChange: (columns: TableColumn[]) => void;
  selectedColumns: TableColumn[];
  availableColumns?: TableColumn[];
};

export const TablePropertiesSidePanel = ({
  isVisible,
  onCloseClick,
  onColumnsChange,
  selectedColumns,
  availableColumns = []
}: TablePropertiesProps) => {
  const { t } = useOptionalTranslation("workflow");

  return (
    <SidePanel show={isVisible} fullHeight onClose={onCloseClick} title={t("parts.tableProperties")}>
      <Stack gap="spacingXl">
        <TableProperties
          selectedColumns={selectedColumns}
          onColumnsChange={onColumnsChange}
          availableColumns={availableColumns}
        />
      </Stack>
    </SidePanel>
  );
};
